import { createSlice } from '@reduxjs/toolkit';

const locationSlice = createSlice({
    name: 'location',
    initialState: {},
    reducers: {}
});

export default locationSlice.reducer;
